<template>
  <div :class="['data-grid-input', condition, {'use-condition': !disableComplex}]">
    <div v-if="!disableComplex && conditionTypes && conditionTypes.length"
         class="condition">
      <el-dropdown placement="bottom-start"
                   @command="selectCondition">
        <div class="el-dropdown-icon theme-text-active theme-light-bg-active"
             :class="{'is-active': conditionChanged}">
          <div class="wrapper"
               :class="{'is-word': conditionType.word}">
            {{conditionType.char}}
          </div>
        </div>
        <el-dropdown-menu slot="dropdown"
                          class="data-grid-input-condition-menu">
          <el-dropdown-item v-for="(conditionType, index) in conditionTypes"
                            :key="'condition_' + index"
                            :command="conditionType.name"
                            :class="{'theme-text theme-light-bg': conditionType.name === condition}">
            <div class="condition-box">
              <div class="icon">
                <div class="wrapper"
                     :class="{'is-word': conditionType.word}">
                  {{conditionType.char}}
                </div>
              </div>
              <div class="text">{{conditionType.text}}</div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="handler">
      <template v-if="isRangeCondition">
        <DataGridInputRange :value="value"
                            v-bind="$attrs"
                            v-on="$listeners"></DataGridInputRange>
      </template>
      <template v-else>
        <el-input v-input-trim
                  :value="value"
                  :type="inputType"
                  :clearable="!isOrCondition && clearable"
                  :disabled="!isDataCondition"
                  v-bind="$attrs"
                  v-on="$listeners">
          <div v-if="isOrCondition"
               slot="suffix"
               class="suffix-wrapper">
            <DataGridInputMultiline title="搜索条件填写"
                                    :value="value"
                                    :divider="or.divider"
                                    @input="onInputChange">
              <template #default="{toggleVisible}">
                <el-button class="theme-text-hover"
                           type="text"
                           icon="el-icon-top-right"
                           @click="toggleVisible"></el-button>
              </template>
            </DataGridInputMultiline>
            <el-button class="theme-text-hover"
                       type="text"
                       icon="el-icon-circle-plus-outline"
                       @click="addOrCondition"></el-button>
          </div>
        </el-input>
      </template>
    </div>
  </div>
</template>

<script>
import DataGridInputRange from './DataGridInputRange'
import DataGridInputMultiline from './DataGridInputMultiline'
import conditionEnum from '../../../constants/conditionEnum'
import inputTrim from '../../../directive/inputTrim'
export default {
  name: 'DataGridInput',
  components: {
    DataGridInputRange,
    DataGridInputMultiline
  },
  directives: {inputTrim},
  props: {
    value: {
      required: false
    },
    type: {
      type: String,
      default: 'text'
    },
    clearable: Boolean,
    condition: {
      type: String,
      default: ''
    },
    disableComplex: {
      type: Boolean
    }
  },
  data () {
    return {
      or: {
        divider: ' | '
      }
    }
  },
  computed: {
    inputType () {
      return this.isOrCondition ? 'text' : this.type
    },
    conditionTypes () {
      switch (this.type) {
        case 'number': {
          return [
            conditionEnum.LIKE,
            conditionEnum.RANGE,
            conditionEnum.GT,
            conditionEnum.LT,
            conditionEnum.EQ,
            conditionEnum.GE,
            conditionEnum.LE,
            conditionEnum.NULL,
            conditionEnum.NOT_NULL,
            conditionEnum.OR
          ]
        }
        case 'text':
        default: {
          return [
            conditionEnum.LIKE,
            conditionEnum.EQ,
            conditionEnum.NULL,
            conditionEnum.NOT_NULL,
            conditionEnum.OR
          ]
        }
      }
    },
    conditionType () {
      let conditionTypes = this.conditionTypes
      if (conditionTypes && conditionTypes.length) {
        let conditionType = conditionTypes.find(conditionType => conditionType.name === this.condition)
        if (conditionType) {
          return conditionType
        }
        return conditionTypes[0]
      }
    },
    conditionChanged () {
      let conditionType = this.conditionType
      if (conditionType) {
        return conditionType !== conditionEnum.LIKE
      }
    },
    isDataCondition () {
      let conditionType = this.conditionType
      if (conditionType) {
        return conditionType.data
      }
    },
    isRangeCondition () {
      let conditionType = this.conditionType
      if (conditionType) {
        return conditionType === conditionEnum.RANGE
      }
    },
    isOrCondition () {
      let conditionType = this.conditionType
      if (conditionType) {
        return conditionType === conditionEnum.OR
      }
    }
  },
  methods: {
    selectCondition (command) {
      this.$emit('update:condition', command)
      this.$nextTick(() => {
        if (this.inputType === 'number' && isNaN(this.value)) {
          this.onInputChange('')
        }
      })
    },
    addOrCondition () {
      let oldValue = this.value || ''
      if (oldValue && !oldValue.endsWith(this.or.divider)) {
        this.$emit('input', oldValue + this.or.divider)
      }
    },
    onInputChange (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
  @use "../../../styles/common" as *;
  .data-grid-input {
    position: relative;
    &.or {
      &>.handler {
        .el-input {
          .el-input__inner {
            padding-right: 50px;
          }
        }
      }
    }
    &>.condition {
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      display: flex;
      align-items: center;
      .wrapper {
        cursor: pointer;
      }
    }
    &.use-condition {
      &>.handler {
        .el-input {
          .el-input__inner {
            padding-left: 30px;
          }
          .el-input__prefix {
            padding-left: 2px;
            .el-dropdown {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
            }
          }
          .el-input__suffix {
            .suffix-wrapper {
              padding-right: 2px;
              .el-button {
                margin-left: 2px;
                color: #909399;
                i {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
  .data-grid-input-condition-menu {
    min-width: 180px;
    margin-left: -7px;
    .condition-box {
      display: flex;
      align-items: center;
      font-size: 12px;
      .text {
        margin-left: 6px;
        padding: 1px 4px;
      }
    }
  }
  .data-grid-input .el-dropdown-icon,
  .data-grid-input-condition-menu .condition-box .icon {
    position: relative;
    width: 16px;
    height: 16px;
    font-size: 12px;
    background: #f7f8f9;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,.08);
    box-sizing: border-box;
    &>.wrapper {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%) scale(.72);
      white-space: nowrap;
      &:not(.is-word) {
        transform: translate(-50%,-50%) scale(.9);
        @extend .console-font;
      }
    }
  }
</style>
